import { render, staticRenderFns } from "./AccountSettings.vue?vue&type=template&id=3ff99d10"
import script from "./AccountSettings.vue?vue&type=script&lang=js"
export * from "./AccountSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ff99d10')) {
      api.createRecord('3ff99d10', component.options)
    } else {
      api.reload('3ff99d10', component.options)
    }
    module.hot.accept("./AccountSettings.vue?vue&type=template&id=3ff99d10", function () {
      api.rerender('3ff99d10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/account-page/account-settings/AccountSettings.vue"
export default component.exports